import { URL, handleErrors } from "./depannageActions"
import { showToast } from "./toastActions"
import { catchApiError } from "./apiHelpers"

export const UPDATE_POINT_INTERET = "UPDATE_POINT_INTERET"

export const FETCH_POINTS_INTERETS_BEGIN = "FETCH_POINTS_INTERETS_BEGIN"
export const FETCH_POINTS_INTERETS_SUCCESS = "FETCH_POINTS_INTERETS_SUCCESS"
export const FETCH_POINTS_INTERETS_ERROR = "FETCH_POINTS_INTERETS_ERROR"

export const fetchPointsInteretsBegin = () => ({
	type: FETCH_POINTS_INTERETS_BEGIN,
})

export const fetchPointsInteretsSucces = (addresses) => ({
	type: FETCH_POINTS_INTERETS_SUCCESS,
	payload: addresses,
})

export const fetchPointsInteretsError = (error) => ({
	type: FETCH_POINTS_INTERETS_ERROR,
	payload: { error },
})

export function fetchPointsInterets() {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchPointsInteretsBegin())
		let url = `${URL}api/points_interets`
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchPointsInteretsSucces(json))
			})
			.catch(catchApiError(dispatch, fetchPointsInteretsError))
	}
}

export const POST_POINTS_INTERETS_BEGIN = "POST_POINTS_INTERETS_BEGIN"
export const POST_POINTS_INTERETS_ERROR = "POST_POINTS_INTERETS_ERROR"
export const POST_POINTS_INTERETS_SUCCESS = "POST_POINTS_INTERETS_SUCCESS"
export const POST_POINTS_INTERETS_RESET = "POST_POINTS_INTERETS_RESET"

export const postPointsInteretsBegin = () => ({
	type: POST_POINTS_INTERETS_BEGIN,
})

export const postPointsInteretsReset = () => ({
	type: POST_POINTS_INTERETS_RESET,
})

export const postPointsInteretsError = (payload) => ({
	type: POST_POINTS_INTERETS_ERROR,
	payload,
})

export const postPointsInteretsSuccess = (payload) => ({
	type: POST_POINTS_INTERETS_SUCCESS,
	payload,
})

export function postPointsInterets(json) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(postPointsInteretsBegin())
		return fetch(`${URL}api/points_interets`, {
			method: "post",
			headers: {
				Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify(json),
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(postPointsInteretsSuccess(json))
				dispatch(showToast("success", "Point d'intérêt enregistré"))
			})
			.catch(catchApiError(dispatch, postPointsInteretsError))
	}
}

export const DELETE_POINT_INTERET_BEGIN = "DELETE_POINT_INTERET_BEGIN"
export const DELETE_POINT_INTERET_SUCCESS = "DELETE_POINT_INTERET_SUCCESS"
export const DELETE_POINT_INTERET_ERROR = "DELETE_POINT_INTERET_ERROR"
export const DELETE_POINT_INTERET_RESET = "DELETE_POINT_INTERET_RESET"

export const deletePointInteretBegin = () => ({
	type: DELETE_POINT_INTERET_BEGIN,
})

export const deletePointInteretReset = () => ({
	type: DELETE_POINT_INTERET_RESET,
})

export const deletePointInteretError = (payload) => ({
	type: DELETE_POINT_INTERET_ERROR,
	payload,
})

export const deletePointInteretSuccess = (payload) => ({
	type: DELETE_POINT_INTERET_SUCCESS,
	payload,
})

export function deletePointInteret(json) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(deletePointInteretBegin())
		return fetch(`${URL}api/points_interets`, {
			method: "delete",
			headers: {
				Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify(json),
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(deletePointInteretSuccess(json))
				dispatch(showToast("success", "Point d'intérêt supprimé"))
			})
			.catch(catchApiError(dispatch, deletePointInteretError))
	}
}
